import { validate } from 'sha-el-design';

export const assignWorkSchema = validate(validate.Object({
  state: validate.Text().required('State is required'),
  town: validate.Text().required('Town is required'),
}));

export enum currentView {
  STATE_AND_EMPLOYEE,
  TOWN,
  DEADLINE,
}

export const assignWorkListQuery = `
query allAssignWorkList($user: ID, $after: Int!, $name: String) {
  finishedFilterAssignWork(
    isFinished: false,
    offset: $after,
    limit: 20,
    supervisor: $user,
    callerName: $name,
  ) {
    id
    dateAssigned
    deadline
    workStatus
    state {
      id
      name
    }
    towns {
      id
      name
      retailerCount
    }
    areas {
      id
      name
      retailerCount
    }
    caller {
      id
      employee {
        id
        name
      }
    }
    totalRetailersCalled
  }
}
`;

export const assignWorkDetailsQuery = `query assignWork($id: ID!){
  assignWork(id: $id) {
    id
    name
    description
    assignWorkType
    options
  }
}`;

export const assignWorkEditQuery = `
query assignWorkDetailsQuery($id: ID!) {
  assignWork(id: $id) {
    id
    name
    description
    assignWorkType
    options
  }
}
`;

export const mutation = `mutation CreateassignWork($input: AssignWorkMutationInput!) {
  createAssignwork(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}`;
